module.exports = __webpack_public_path__ + "static/media/nuestros_clientes_testimonio1.4bab8073.png";